import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { NavigateRoutes, QK_CONSTATANT, RequestType, StorageConstants, TECH_CONSTATANT } from 'common/constants/app.constant';
import { RouteMessage } from 'common/models/utilitymodels/base.model';
import { StorageService } from 'common/services/core_services/storage.service';
import { SystemService } from 'common/services/core_services/system.service';

@Injectable({
    providedIn: 'root',
})
export class DashboardGuard implements CanActivate {
    constructor(private systemService: SystemService, private storageService: StorageService) { }
    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
        let userData = JSON.parse(this.systemService.getLocalStorage(StorageConstants.userProfile));
        if (userData) {
            if (userData && this.systemService.deviceInfo.platform !== 'web' && !this.systemService.getSesstionStorage(StorageConstants.isLoginSuccessOnMob)) {
                this.storageService.clearStorage();
                const routeMessage = new RouteMessage();
                routeMessage.type = RequestType.BLANK;
                this.systemService.routeByUrl(NavigateRoutes.loginViaOtp, routeMessage);
                return false;
            }
            if (userData?.type === 'IFA_USER' && !QK_CONSTATANT.includes(userData.arnNo) && !TECH_CONSTATANT.includes(userData.arnNo)) {
                return true;
            } else {
                const routeMessage = new RouteMessage();
                routeMessage.type = RequestType.BLANK;
                this.systemService.routeByUrl(NavigateRoutes.initiateTransaction, routeMessage);
            }
        } else {
            const routeMsg = new RouteMessage();
            routeMsg.type = RequestType.BLANK;
            routeMsg.transferData = null;
            this.systemService.routeByUrl(NavigateRoutes.baselogin, routeMsg);
            return false;
        }
    }
}


